import { Suspense } from 'react';
import { Route, Router, Switch } from 'wouter';
import { Spinner } from '../components/loading/Spinner';
import { routeConfig } from './RouteConfig';

/**
 * Loading component for better reusability
 */
const PageLoader = () => (
  <div
    id="loader-fallback"
    className="flex h-screen w-full items-center justify-center z-[9999]"
  >
    <Spinner />
  </div>
);

/**
 * Main Routes component that renders all application routes
 */
export function Routes() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Router>
        <Switch>
          {routeConfig.map(({ path, component: Component }) => (
            <Route key={path} path={path} component={Component} />
          ))}
        </Switch>
      </Router>
    </Suspense>
  );
}
